//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
import { ChevronDownIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Checkbox,
  CheckboxGroup,
  Flex,
  Input,
  InputGroup,
  InputRightElement,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Stack,
  Text,
} from "@chakra-ui/react";
import Pluralize from "pluralize";
import React, { useEffect } from "react";
import Icon from "../ui-elements/Icon";
import { handleKeyDown } from "../ZetaComponents/ZetaInput";

export const InputLikeButton = React.forwardRef((props: any, ref) => {
  const { children, onClick, placeholder, isOpen, ...rest } = props;
  return (
    <InputGroup {...rest}>
      <InputRightElement
        zIndex="base"
        children={
          <ChevronDownIcon
            fontSize="2xl"
            mr="4px"
            style={{
              transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
              transition: "all 0.2s cubic-bezier(0.645, 0.045, 0.355, 1)",
              transformOrigin: "50% 50%",
            }}
          />
        }
      />
      <Input
        {...{ children, placeholder, ref, onClick }}
        color={children === "Select subjects" ? "gray.400" : "gray.700"}
        as="button"
        type="button"
        isReadOnly
        cursor="default"
        textAlign="left"
        overflow="hidden"
        {...rest}
      />
    </InputGroup>
  );
});

const SelectComms = ({ value, options, onChange, variantColor, ...rest }) => {
  return (
    <Popover placement="bottom-start">
      {({ onClose }) => (
        <>
          <PopoverTrigger>
            <InputLikeButton
              borderRight={0}
              borderRadius="noRightRadius"
              {...rest}
            >
              <Icon
                color={`${value || options[0]}.500`}
                name={value || options[0]}
              />
            </InputLikeButton>
          </PopoverTrigger>
          <PopoverContent
            p={0}
            zIndex="popover"
            maxW="160px"
            _focus={{ outline: "none" }}
          >
            {options.map((option) => (
              <Box
                p="12px 16px"
                tabIndex={"-1" as any}
                key={option}
                cursor="pointer"
                bg={value === option ? `${variantColor}.50` : "white"}
                _active={{ outline: "none" }}
                onClick={() => {
                  onChange && onChange(option);
                  onClose();
                }}
              >
                <Stack isInline align="center" spacing={3}>
                  <Icon name={option} color={`${option}.500`} />
                  <Text lineHeight="none">{option}</Text>
                </Stack>
              </Box>
            ))}
          </PopoverContent>
        </>
      )}
    </Popover>
  );
};

export const QuickSelect = ({
  value,
  onChange,
  placeholder,
  onBlur,
  variantColor = "blue",
  fontSize,
  size,
  ...rest
}) => {
  const [values, setValues] = React.useState(
    value || { channel: "", number: "" }
  );

  useEffect(() => {
    setValues(value);
  }, [value]);

  const handleChange = (key, value) => {
    let newValues = { ...values, [key]: value };
    setValues(newValues);
    onChange && onChange(newValues);
  };

  return (
    <Flex align="center">
      <SelectComms
        // options={["whatsapp", "telegram"]}
        options={["whatsapp"]}
        onChange={(value) => handleChange("channel", value)}
        value={values.channel}
        size={size || "lg"}
        variantColor={variantColor}
        {...rest}
      />

      <Input
        id="preferredCommsNumber"
        type="tel"
        placeholder={placeholder}
        onBlur={onBlur}
        size={size || "lg"}
        onKeyDown={handleKeyDown as any}
        fontSize={fontSize || "16px"}
        value={values.number}
        onChange={(e) => handleChange("number", e.target.value)}
        borderRadius="noLeftRadius"
        {...rest}
      />
    </Flex>
  );
};

type DropDownCheckboxType = {
  value: any;
  options: Array<any>;
  onChange: any;
  variantColor: any;
  placeholder: string;
  [key: string]: any;
};

export const DropDownCheckbox = ({
  value: valueProp = [],
  options = [],
  onChange = () => {},
  variantColor = "blue",
  placeholder,
  ...rest
}: DropDownCheckboxType) => {
  const [values, setValues] = React.useState(valueProp);

  function handleChange(value) {
    setValues(value);
    onChange(value);
  }

  React.useEffect(() => {
    onChange(values);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values]);

  React.useEffect(() => setValues(valueProp), [valueProp]);

  return (
    <Popover placement="bottom">
      {({ isOpen, onClose }) => (
        <Box position="relative">
          <PopoverTrigger>
            <InputLikeButton isOpen={isOpen} {...rest}>
              {values.length > 0
                ? Pluralize("subject", values.length, true)
                : placeholder}
            </InputLikeButton>
          </PopoverTrigger>
          <PopoverContent
            position="absolute"
            minW="100%"
            px={[3, 4]}
            py={[2, 3]}
            zIndex="popover"
            _focus={{ outline: "none" }}
          >
            <CheckboxGroup
              // colorScheme={variantColor}
              // spacing={3}
              value={values}
              onChange={handleChange}
            >
              {options.map((option, index) => (
                <Checkbox
                  key={index}
                  defaultChecked={option.defaultIsChecked}
                  isDisabled={option.defaultIsChecked}
                  value={option.value}
                >
                  {option.label}
                </Checkbox>
              ))}
            </CheckboxGroup>

            <Button ml="auto" mt={4} w={["60%", "50%"]} onClick={onClose}>
              Save
            </Button>
          </PopoverContent>
        </Box>
      )}
    </Popover>
  );
};
